module.exports = __webpack_public_path__ + "img/ellipse-particulier@2x.5a725cd2.png";